const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wealth-freedom-nav/artifacts/wdt06ylk_SAHI%20DISHA%20FINAL-06.jpeg";

export default function Footer() {
  return (
    <footer
      className="border-t border-white/10 bg-[#060912]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Sahi Disha" className="h-16 w-auto rounded-lg bg-white p-1.5" />
            <div>
              <div className="font-heading font-semibold tracking-tight">
                Sahi Disha Financial Services Pvt. Ltd.
              </div>
              <div className="text-xs text-[#F97316] uppercase tracking-[0.18em] mt-0.5">
                Navigating Your Wealth
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:items-end gap-1 text-xs text-slate-500">
            <div>© {new Date().getFullYear()} Sahi Disha Financial Services Pvt. Ltd.</div>
            <div className="max-w-md sm:text-right">
              Projections are indicative only. Mutual fund investments are subject to market risks;
              read all scheme related documents carefully.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
